import React ,{useState} from "react";
import "./htmlGameItem.css";
import { useNavigate } from "react-router-dom";
import { notify1 } from "../ToastComponent";
import { useTranslation } from "react-i18next";
import ReactiveSubscriptionModal from "../../Components/ReactiveSubscription/ReactiveSubscription";
import NoBalanceModal from "../../Components/NoBalanceModal/NoBalanceModal";

const Html5GameItem = ({ html_game }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const canPlay = JSON.parse(localStorage.getItem("can_play"));
  const hostName =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("libyad") || window.location.hostname.includes("gamerclub.ly");
  const [showSubModal, setShowSubModal] = useState(false);
  const [showNoBalanceModal, setShowNoBalanceModal] = useState(false);

  const openReactiveSubscriptionModal = () => setShowSubModal(true);
  const closeReactiveSubscriptionModal = () => setShowSubModal(false);
  const openNoBalanceModal = () => setShowNoBalanceModal(true);
  const closeNoBalanceModal = () => setShowNoBalanceModal(false);

  const handlePlayClick = (gameId) => {
    if (!token) {
      notify1("Please Sign in first");
      return;
    }
    if (!canPlay && hostName) {
      const blockReason = localStorage.getItem("subscription_block_reason");
      if (blockReason === "no_balance") {
        openNoBalanceModal();
      } else {
        openReactiveSubscriptionModal();
      }
    } else {
      navigate(`/play/${html_game?.id}`);
    }
  };
  return (
    <div className="htmlGame-item">
      <img
        src={html_game?.photo}
        alt="game_1"
        loading="lazy"
        onClick={() => navigate(`/htmlGameDetails/${html_game?.id}`)}
      />
      <div
        className="btn-join"
       onClick={() => handlePlayClick(html_game?.id)}
      >
        <span>{t("play now")}</span>
      </div>
          <ReactiveSubscriptionModal
  show={showSubModal}
  onClose={closeReactiveSubscriptionModal}
/>
      <NoBalanceModal show={showNoBalanceModal} onClose={closeNoBalanceModal} />
    </div>
  );
};

export default Html5GameItem;
